import { Action as ReduxAction, Dispatch } from 'redux';
import { LineStyle } from '../../reducers/ui/ui';
import { LineType } from '../../drawing/types';
import { Color } from '../../types/color';
import { FreehandPenWidth } from '../../types/freehandPenWidth';

namespace FreehandPenUIAction {
  export enum ActionType {
    SELECT_TOOL = 'UI_FREEHAND_PEN_SELECT_TOOL',
    SET_PEN_COLOR = 'UI_FREEHAND_PEN_SET_PEN_COLOR',
    SET_PEN_WIDTH = 'UI_FREEHAND_PEN_SET_PEN_WIDTH',
    SET_LINE_TYPE = 'UI_FREEHAND_PEN_SET_LINE_TYPE',
    SET_LINE_STYLE = 'UI_FREEHAND_PEN_SET_LINE_STYLE',
  }

  interface SelectToolAction extends ReduxAction {
    type: typeof ActionType.SELECT_TOOL;
    selected: number;
  }

  interface SetColorAction extends ReduxAction {
    type: typeof ActionType.SET_PEN_COLOR;
    selected: number;
    color: Color;
  }

  interface SetLineWidthAction extends ReduxAction {
    type: typeof ActionType.SET_PEN_WIDTH;
    selected: number;
    width: FreehandPenWidth;
  }

  interface SetLineTypeAction extends ReduxAction {
    type: typeof ActionType.SET_LINE_TYPE;
    selected: number;
    lineType: LineType;
  }

  interface SetLineStyleAction extends ReduxAction {
    type: typeof ActionType.SET_LINE_STYLE;
    selected: number;
    lineStyle: LineStyle;
  }

  export type Action =
    SelectToolAction
    | SetColorAction
    | SetLineWidthAction
    | SetLineTypeAction
    | SetLineStyleAction;

  export function isDomesticAction(action: ReduxAction): action is Action {
    return Object.keys(ActionType).some(k => action.type === ActionType[k as any]);
  }

  export function selectTool(selected: number, dispatch: Dispatch<ReduxAction>) {
    dispatch({ selected, type: ActionType.SELECT_TOOL });
  }

  export function setPenColor(selected: number, color: Color, dispatch: Dispatch<ReduxAction>) {
    dispatch({ selected, color, type: ActionType.SET_PEN_COLOR });
  }

  export function setWidth(
    selected: number,
    width: FreehandPenWidth,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, width, type: ActionType.SET_PEN_WIDTH });
  }

  export function setLineType(
    selected: number,
    lineType: LineType,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, lineType, type: ActionType.SET_LINE_TYPE });
  }

  export function setLineStyle(
    selected: number,
    lineStyle: LineStyle,
    dispatch: Dispatch<ReduxAction>,
  ) {
    dispatch({ selected, lineStyle, type: ActionType.SET_LINE_STYLE });
  }
}

export default FreehandPenUIAction;
